// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/switch/index.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Primary } from './Primary.story';
import { Disabled } from './Disabled.story';
import { Controlled } from './Controlled.story';
import { Uncontrolled } from './Uncontrolled.story';
const basic = {
  rendered: <Primary />,
  source: `<Switch
  label="This is a Switch."
  onChange={(e) => {
    console.log(e.target.checked);
  }}
/>`
};
const controlled = {
  rendered: <Controlled />,
  source: `const [checked, setChecked] = React.useState(false);

return (
  <Switch
    onChange={() => {
      setChecked(!checked);
    }}
    checked={checked}
    label="This Switch is controlled."
  />
);`
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<Switch
  onChange={(e) => {
    console.log(e.target.checked);
  }}
  defaultChecked
  label="This Switch is uncontrolled."
/>`
};
const disabled = {
  rendered: <Disabled />,
  source: `const [checked, setChecked] = React.useState(false);
  
return (
  <Box
    css={{
      layout: 'column',
      gap: 'medium',
    }}
  >
    <Switch
      label="This uncontrolled Switch is disabled."
      defaultChecked
      disabled
    />
    <Switch
      onChange={() => {
        setChecked(!checked);
      }}
      checked={checked}
      disabled
      label="This controlled Switch is disabled."
    />
  </Box>
);`
};
export const SwitchExamples = {
  basic,
  controlled,
  uncontrolled,
  disabled
};